var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutonomousTesting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#102C60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12L10.3125 10.3438L12 9.5L10.3125 8.6875L9.5 7L8.65625 8.6875L7 9.5L8.65625 10.3438L9.5 12ZM20.4688 16L19.6562 17.6875L17.9688 18.5L19.6562 19.3438L20.4688 21L21.3125 19.3438L22.9688 18.5L21.3125 17.6875L20.4688 16ZM13.9688 10L14.4688 9L15.4688 8.5L14.4688 8L13.9688 7L13.4688 8L12.4688 8.5L13.4688 9L13.9688 10ZM20.4688 13C20.75 13 20.9688 12.7812 20.9688 12.5V11.4375L22.6875 9.5625C23.0938 9.09375 23.0938 8.375 22.625 7.90625L22.0938 7.375C21.625 6.90625 20.9062 6.90625 20.4375 7.3125L11.9062 15H10.5C10.2188 15 10 15.25 10 15.5V16.75L7.53125 18.9688C7.1875 19.25 7 19.6875 7 20.1562C6.96875 20.5938 7.15625 21.0312 7.46875 21.3438L8.65625 22.5312C8.9375 22.8438 9.375 23 9.8125 23C10.5 23 10.9375 22.5938 11.0312 22.4688L19.5625 13H20.4688ZM9.9375 21.4688C9.90625 21.5 9.78125 21.5625 9.71875 21.4688L8.53125 20.3125C8.4375 20.1875 8.5 20.0938 8.53125 20.0625L21.2188 8.625L21.375 8.78125L9.9375 21.4688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutonomousTesting);
export default __webpack_public_path__ + "static/media/autonomous-testing.33aa68d066c16050c1c4c950a2e5c280.svg";
export { ForwardRef as ReactComponent };